<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Add Team</span>
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    class="mt-6 flex flex-col p-4"
  >
    <div class="flex flex-col space-y-2">
      <span class="font-medium">Team Name</span>
      <input
        formControlName="name"
        type="text"
        class="w-full sm:w-2/3 h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
        placeholder="Masukkan nama team"
      />
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <span class="font-medium">Description</span>
      <textarea
        formControlName="description"
        type="text"
        class="w-full sm:w-2/3 h-32 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
        placeholder="Masukkan deskripsi"
      ></textarea>
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <span class="font-medium">Expense Category</span>
      <mat-select
        multiple
        type="text"
        class="!w-full sm:!w-2/3 h-12 rounded-lg !text-sm px-4 py-3 !text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display !tracking-normal"
        placeholder="Pilih kategori expense"
      >
        <mat-option class="!font-display !text-sm !tracking-normal"
          >Loan</mat-option
        >
        <mat-option class="!font-display !text-sm !tracking-normal"
          >Expense</mat-option
        >
      </mat-select>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mt-8">
      <button
        [disabled]="form.invalid"
        class="w-full sm:w-80 h-12 rounded-lg bg-[#85E2B1] text-white flex items-center justify-center space-x-2"
      >
        <span>Save</span>
      </button>
      <button
        type="button"
        (click)="cancel()"
        class="w-full sm:w-80 h-12 rounded-lg bg-gray-400 text-white flex items-center justify-center space-x-2"
      >
        <span>Cancel</span>
      </button>
    </div>
  </form>
</section>
